import AlgoliaCollection from '@components/collection/AlgoliaCollection'
import SearchClient, {
  getDefaultSearchString,
  pathToSearchState,
} from '@lib/algolia'
import { useRouter } from 'next/router'

export default function Search() {
  let { query, asPath, pathname} = useRouter()
  let { q } = query
  if (!q) q = ''

  const algoliaIndex = process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_PRIMARY_INDEX!
  // const defaultfilterString = getDefaultSearchString()
  const searchState = pathToSearchState(asPath)

  return (
    <>
      <div className="wrapper">
        <h1 className="text-xl py-5">
          <span className="">Showing results for</span>
          <span className="font-bold">{` "${q}"`}</span>
        </h1>
      </div>
      <AlgoliaCollection
        searchClient={SearchClient}
        indexName={algoliaIndex}
        searchState={searchState}
        defaultCategory=""
        searchTerm={q && Array.isArray(q) ? q[0] : q}
        pathname={pathname}
      />
    </>
  )
}